var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      [
        _c(
          "v-container",
          { attrs: { fluid: "", "grid-list-md": "" } },
          [
            _c(
              "v-layout",
              [
                _c(
                  "v-flex",
                  { attrs: { xs12: "", sm6: "", md2: "" } },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        items: _vm.lsEventoTipo,
                        label: "Eventos",
                        "item-value": "id",
                        "item-text": "nombre",
                        "error-messages": _vm.errors.collect("eventos"),
                        "no-data-text": "Sin resultados",
                        autocomplete: ""
                      },
                      model: {
                        value: _vm.filtroGrillaEvento,
                        callback: function($$v) {
                          _vm.filtroGrillaEvento = $$v
                        },
                        expression: "filtroGrillaEvento"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-flex",
                  { attrs: { xs12: "", sm6: "", md2: "" } },
                  [
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "close-on-content-click": false,
                          "nudge-right": 40,
                          lazy: "",
                          transition: "scale-transition",
                          "offset-y": "",
                          "full-width": "",
                          "max-width": "290px",
                          "min-width": "290px"
                        },
                        model: {
                          value: _vm.menuDatePickerFechaD,
                          callback: function($$v) {
                            _vm.menuDatePickerFechaD = $$v
                          },
                          expression: "menuDatePickerFechaD"
                        }
                      },
                      [
                        _c("v-text-field", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "",
                              expression: "''"
                            }
                          ],
                          attrs: {
                            slot: "activator",
                            label: "Fecha Desde",
                            "persistent-hint": "",
                            "prepend-icon": "event",
                            "error-messages": _vm.errors.collect("fechaDesde"),
                            "data-vv-name": "fechaDesde",
                            readonly: ""
                          },
                          slot: "activator",
                          model: {
                            value: _vm.computedDateFormattedFechaD,
                            callback: function($$v) {
                              _vm.computedDateFormattedFechaD = $$v
                            },
                            expression: "computedDateFormattedFechaD"
                          }
                        }),
                        _c("v-date-picker", {
                          key: _vm.keyDatePickers,
                          attrs: {
                            "first-day-of-week": "1",
                            locale: "es-cl",
                            scrollable: "",
                            max: _vm.maxDate
                          },
                          on: {
                            input: function($event) {
                              _vm.menuDatePickerFechaD = false
                            }
                          },
                          model: {
                            value: _vm.filtroGrillaFechaD,
                            callback: function($$v) {
                              _vm.filtroGrillaFechaD = $$v
                            },
                            expression: "filtroGrillaFechaD"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-flex",
                  { attrs: { xs12: "", sm6: "", md2: "" } },
                  [
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "close-on-content-click": false,
                          "nudge-right": 40,
                          lazy: "",
                          transition: "scale-transition",
                          "offset-y": "",
                          "full-width": "",
                          "max-width": "290px",
                          "min-width": "290px"
                        },
                        model: {
                          value: _vm.menuDatePickerFechaH,
                          callback: function($$v) {
                            _vm.menuDatePickerFechaH = $$v
                          },
                          expression: "menuDatePickerFechaH"
                        }
                      },
                      [
                        _c("v-text-field", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "",
                              expression: "''"
                            }
                          ],
                          attrs: {
                            slot: "activator",
                            label: "Fecha Hasta",
                            "persistent-hint": "",
                            "prepend-icon": "event",
                            "error-messages": _vm.errors.collect("fechaHasta"),
                            "data-vv-name": "fechaHasta",
                            readonly: ""
                          },
                          slot: "activator",
                          model: {
                            value: _vm.computedDateFormattedFechaH,
                            callback: function($$v) {
                              _vm.computedDateFormattedFechaH = $$v
                            },
                            expression: "computedDateFormattedFechaH"
                          }
                        }),
                        _c("v-date-picker", {
                          key: _vm.keyDatePickers,
                          attrs: {
                            "first-day-of-week": "1",
                            locale: "es-cl",
                            scrollable: "",
                            min: _vm.minDate
                          },
                          on: {
                            input: function($event) {
                              _vm.menuDatePickerFechaH = false
                            }
                          },
                          model: {
                            value: _vm.filtroGrillaFechaH,
                            callback: function($$v) {
                              _vm.filtroGrillaFechaH = $$v
                            },
                            expression: "filtroGrillaFechaH"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("v-flex", { attrs: { xs12: "", sm6: "", md2: "" } }, [
                  _c(
                    "div",
                    { attrs: { align: "left" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Buscar...",
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("v-flex", { attrs: { xs12: "", sm6: "", md1: "" } }, [
                  _c(
                    "div",
                    { staticClass: "text-xs-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", icon: "", small: "" },
                          on: { click: _vm.getDataFilter }
                        },
                        [_c("v-icon", [_vm._v("search")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            flat: "",
                            icon: "",
                            small: "",
                            disabled: _vm.btnDisabled
                          },
                          on: { click: _vm.clearFilters }
                        },
                        [_c("v-icon", [_vm._v("clear")])],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "v-flex",
                  { attrs: { xs12: "", sm6: "", md1: "" } },
                  [
                    _c("ExportarAgGridButton", {
                      attrs: {
                        permisoAccion: _vm.accionExportar,
                        "column-defs": _vm.columnDefs,
                        "row-data": _vm.eventos,
                        "exported-file-name": "EventosCopiloto"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      _c("MantenedorGridTodos", {
        attrs: { "grid-options": _vm.gridOptions, "funcionalidad-id": 0 }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }